import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WsMenuComponent } from './ws-menu.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from "../../modules/feature-toggle/feature-toggle.module";
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    MatIconModule,
    TranslateModule,
    WsTooltipModule,
    FeatureToggleModule,
    WsUiModule,
    HttpClientModule,
    RouterModule.forChild([])
],
  declarations: [WsMenuComponent],
  exports: [WsMenuComponent]
})
export class WsMenuModule { }
